module.exports = "/images/london-14.jpg";